import { CSSProperties } from "react";
import { Extent } from "ol/extent";

// export const OPEN_LAYER_EXTENT: Extent = [-180, -90, 180, 90];
export const OPEN_LAYER_EXTENT: Extent = [0, 0, 1024, 768];

export const DEFAULT_ICON_COLOR: CSSProperties["color"] = "#f0a";
